module.exports = __webpack_public_path__ + "img/154.6b9e04f0.png";